import { render, staticRenderFns } from "./BookingSideMenu.vue?vue&type=template&id=6cef229e&scoped=true"
import script from "./BookingSideMenu.vue?vue&type=script&lang=js"
export * from "./BookingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./BookingSideMenu.vue?vue&type=style&index=0&id=6cef229e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef229e",
  null
  
)

export default component.exports